export const getWorkerId = () => {
    var _a;
    return (_a = globalThis.workerId) !== null && _a !== void 0 ? _a : "main";
};
